import { useState } from "react";
import { getCustomisationValue, getGroupData } from "../../EditablePreview";
import InlineProgressBar, { convertCustomisationDataToBarSettings } from "../progress-bar/inline-progress-bar";
import VisualisedNode from "../VisualisedNode";
// import './WaveProgressBar.scss';

const GenericProgressBar = (props) => {
    // console.log("GenericProgressBar props:", props);

    const progressBarGroupLinkage = props.node?.config?.groupSettings?.dataLink?.split('.');
    const progressBarGroupPath = progressBarGroupLinkage ? progressBarGroupLinkage[0] + '.' + progressBarGroupLinkage[1] : null;

    const dir = props.dir === 'vertical' ? 'vertical' : 'horizontal';
    const w = (dir === "horizontal" ? 1920 : 1080) * (getCustomisationValue(props.node.customisationVars, progressBarGroupPath ? progressBarGroupPath + '.shape.length' : 'progressBar.shapeAndPosition.shape.length') / 100) * props.previewScale;
    const h = getCustomisationValue(props.node.customisationVars, progressBarGroupPath ? progressBarGroupPath + '.shape.thickness' : 'progressBar.shapeAndPosition.shape.thickness') * props.previewScale;

    // console.log("GenericProgressBar dimensions:", {w, h}, progressBarGroupPath);

    // transform: rotate(-90deg) translate(-500px, 0); transform-origin: top left;
    const transformStyle = {};
    if (dir === "vertical") {
        transformStyle.transform = `rotate(-90deg) translate(-${w}px, 0)`;
        transformStyle.transformOrigin = "top left";
    }

    return (
        <div style={transformStyle}>
            <InlineProgressBar
                viewId={`generic-progress-bar-${props.node.id}`}
                customSettings={getGroupData(props.node.customisationVars, progressBarGroupPath ? progressBarGroupPath : 'progressBar')}
                fillPerc={props?.fillPerc ?? 0.7}
                useOutline={true}
                stripeWidth={props.stripeWidth || 10}
                // dir={dir}
                width={w/*dir === 'horizontal' ? w : h*/}
                height={h/*dir === 'horizontal' ? h : w*/}
            />
        </div>
    )
}

export default GenericProgressBar;
